import { Mensaje } from "../../controls/Mensaje"
import { logErrors } from "../../logErrors"
import { listar_municipalidades } from "../../helpers/municipalidadHelper"
import { getMunicipalidades } from "../actions/municipalidadActions"
import { municipalidadTypes } from "../../types/municipalidadTypes"

export const getMunicipalidadesBD = ( region, provincia, distrito, all='si' ) => {
    return async( dispatch, getState ) => {
        try {
            dispatch( getMunicipalidades( [] ) )
            
            const response = await listar_municipalidades( region, provincia, distrito, all )
            
            if ( response.Validacion !== '' ){
                dispatch( { type: municipalidadTypes.MUNICIPALIDAD_GET_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
            }
            else{
                dispatch( { type: municipalidadTypes.MUNICIPALIDAD_GET_COMPLETE, 
                    payload: response.Data } );
            }

        } catch ( e ) {
            dispatch( { type: municipalidadTypes.MUNICIPALIDAD_GET_ERROR, payload: [] } );
            const err = logErrors( e )
            Mensaje( err.Message, err.Type )
        }
        
    }
}